// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AzurePipelinesIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 36 36">
    <path fill="#91B0F2" d="M0 27h2.7v6.3H9V36H0z" />
    <path
      fill="#0F46BD"
      d="M0 10.5v8.25l5.25 5.4 2.25-2.4 6.75 6.75L12 30.75l5.25 5.24h8.25a1.5 1.5 0 0 0 1.5-1.5v-12L13.5 9h-12A1.5 1.5 0 0 0 0 10.5"
    />
    <path
      fill="#2560E0"
      d="M6.5 21.65a1.5 1.5 0 0 1-.2-1.89L18.6 1.34A3 3 0 0 1 21.1 0h13.4A1.5 1.5 0 0 1 36 1.5v13.4a3 3 0 0 1-1.33 2.5L16.24 29.7a1.5 1.5 0 0 1-1.9-.2z"
    />
    <path fill="#0A44C2" d="m7.48 26.3 11.45-11.45 2.22 2.22L9.7 28.52z" />
    <path fill="#729AF2" d="m7.48 26.3 11.45-11.45 2.22 2.22L9.7 28.52z" />
    <path fill="#4C80F0" d="m11.53 26.69-2.22-2.22 9.62-9.62 2.22 2.22z" />
    <path fill="#0A44C2" d="M27 13.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9" />
    <path fill="#91B0F2" d="M27 13.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9" />
    <g opacity={0.2}>
      <path
        fill="url(#azure-pipelines_svga)"
        d="m5.25 24.16 1.81-1.94 2.26 2.25-1.84 1.83 2.22 2.22 1.83-1.83 2.26 2.26-1.8 1.8 5.26 5.24h8.25a1.5 1.5 0 0 0 1.5-1.5v-12l7.66-5.1a3 3 0 0 0 1.34-2.5V1.5A1.5 1.5 0 0 0 34.5 0H21.1a3 3 0 0 0-2.5 1.34L13.5 9h-12A1.5 1.5 0 0 0 0 10.5v8.25z"
      />
      <path fill="url(#azure-pipelines_svgb)" d="M2.7 27H0v9h9v-2.7H2.7z" />
    </g>
    <defs>
      <linearGradient
        id="azure-pipelines_svga"
        x1={18.01}
        x2={18.01}
        y1={0.01}
        y2={36.01}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="azure-pipelines_svgb"
        x1={4.51}
        x2={4.51}
        y1={0.01}
        y2={36.01}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>,
  "AzurePipelines",
);
export default AzurePipelinesIcon;
